import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './SimpleAccordion.scss';

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#212121'
  },
  accordionRoot: {
    marginBottom: '0',
    marginTop: 0,
    width: '100%',
    height: 'fit-content',
    minHeight: '48px',
    expanded: {
      marginTop: 0
    }
  },
  accordionDetails: {
    width: '100%',
    display: 'inline-block'
  },
  accordionSummary: {
    minHeight: '50px',
    borderTop: '1px solid #E0E0E0',
    color: '#E0E0E0'
  },
  expanded: {
    accordionSummary: {
      minHeight: '48px'
    }
  },
  expandIcon: {
    width: '20px',
    height: '20px'
  }
}));

function SimpleAccordion({ defaultExpanded, index, panelTitle, panelDetails }) {
  const classes = useStyles();

  return (
    <Accordion className={classes.accordionRoot} defaultExpanded={defaultExpanded}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        aria-controls={`panel${index}a-content`}
        id={`panel${index}a-header`}
      >
        <Typography className={classes.heading}>{panelTitle}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>{panelDetails}</AccordionDetails>
    </Accordion>
  );
}

export default SimpleAccordion;
